import { Fragment } from "react";
import * as Scrivito from "scrivito";

Scrivito.provideComponent("LinkContainerWidget", ({ widget }) => (
  <Fragment>
    <Scrivito.ContentTag
      className={`page-list --columns-${widget.get("columns") || 1}`}
      tag="ul"
      content={widget}
      attribute="links"
    />
  </Fragment>
));
